import React, { createContext, useContext, useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface SystemConfig {
  allowNewSignups: boolean;
  enableAIFeatures: boolean;
  maintenanceMode: boolean;
}

const defaultConfig: SystemConfig = {
  allowNewSignups: true,
  enableAIFeatures: true,
  maintenanceMode: false,
};

interface SystemContextType {
  config: SystemConfig;
  loading: boolean;
}

const SystemContext = createContext<SystemContextType>({ config: defaultConfig, loading: true });

export const useSystem = () => useContext(SystemContext);

export function SystemProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<SystemConfig>(defaultConfig);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      try {
        const snap = await getDoc(doc(db, 'system', 'config'));
        if (cancelled) return;
        if (snap.exists()) {
          setConfig({ ...defaultConfig, ...snap.data() } as SystemConfig);
        }
      } catch (error) {
        console.error('Error fetching system config:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <SystemContext.Provider value={{ config, loading }}>
      {children}
    </SystemContext.Provider>
  );
}
